import * as React from 'react';
import Context from '../../State/Context';
import Markdown from '../Markdown';
import {
	FormControl,
	InputLabel,
	MenuItem,
	Select,
} from '../MlrForm';
import Tooltip from '../Tooltip';

const onlyUnique = (value: string, index: number, self: string[]) => {
    return self.indexOf(value) === index;
};

export default class ContentPropertyLocation extends React.Component {
    public render() {
        return (
            <Context.Consumer>
            {({ suburbs, messages, userState, onChangeSuburb, onChangeClimateZone }) => {
                const { title, description, labelSuburb, labelClimateZone, placeholderSelectSuburb, placeholderSelectClimateZone, tooltipSuburb, tooltipClimateZone } = messages.page1;
                const suburb = userState.suburb.value;
                const climateZone = userState.climateZone.value;
                const uniqueSuburbs = suburbs.map(item => item.name).filter(onlyUnique);
                const filteredZones = suburbs
                    .filter(item => item.name === suburb)
                    .map(item => item.zone)
                    .filter(onlyUnique).sort();

                return (
                    <div>
                        <h2>{title}</h2>
                        <Markdown source={description} />
                        <div>
                            <FormControl>
                                <InputLabel htmlFor="select-suburb">
                                    {labelSuburb} <Tooltip text={tooltipSuburb} position="right"/>
                                </InputLabel>
                                <Select id="select-suburb" value={suburb} onChange={onChangeSuburb}>
                                    <MenuItem value="" disabled={true}>{placeholderSelectSuburb}</MenuItem>
                                    {uniqueSuburbs.map(item => <MenuItem key={item}>{item}</MenuItem>)}
                                </Select>
                            </FormControl>
                            
                            {filteredZones.length === 0 && typeof suburb === 'string' && suburb.length > 0 && (
                                <div>
                                    This feature has not been implemented.
                                </div>
                            )}

                            {filteredZones.length === 1 && (
                                <FormControl>
                                    <InputLabel htmlFor="select-climate-zone">
                                        {labelClimateZone} <Tooltip text={tooltipClimateZone} position="right"/>
                                    </InputLabel>
                                    <Select id="select-climate-zone" value={filteredZones[0]} onChange={onChangeClimateZone}>
                                        {filteredZones.map(item => <MenuItem key={item}>{item}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            )}

                            {filteredZones.length > 1 && (
                                <FormControl>
                                    <InputLabel htmlFor="select-climate-zone">
                                        {labelClimateZone} <Tooltip text={tooltipClimateZone} position="right"/>
                                    </InputLabel>
                                    <Select id="select-climate-zone" value={climateZone} onChange={onChangeClimateZone}>
                                        <MenuItem value="" disabled={true}>{placeholderSelectClimateZone}</MenuItem>
                                        {filteredZones.map(item => <MenuItem key={item}>{item}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            )}
                        </div>
                    </div>
                )
            }}
            </Context.Consumer>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/Pages/PropertyLocation.tsx